<template>
    <div class="step-result">
        <h3>✅ Import terminé</h3>
        <p>
            Le classement <strong>"{{ params.name || 'PDF fédéral' }}"</strong> a été importé et alimente à la fois
            le classement de ce tournoi et le classement général de la saison.
        </p>
        <ul class="result-summary">
            <li v-if="'rows_imported' in result">{{ (result as any).rows_imported }} ligne(s) importée(s).</li>
            <li v-if="'entries_count' in result">{{ (result as any).entries_count }} entrée(s) importée(s) (catégorie {{ (result as any).category }}).</li>
        </ul>
        <button type="button" class="btn-submit" @click="$emit('restart')">Nouvel import</button>
    </div>
</template>

<script setup lang="ts">
import type { WizardParams } from './types'

defineProps<{ params: WizardParams; result: Record<string, unknown> }>()
defineEmits<{ restart: [] }>()
</script>

<style scoped>
.step-result h3 {
    margin-bottom: 1rem;
    color: var(--color-success, #38c793);
}

.result-summary {
    margin: 1rem 0;
    padding-left: 1.2rem;
}

.btn-submit {
    display: inline-flex;
    align-items: center;
    padding: 0.6rem 1.2rem;
    border-radius: var(--radius, 8px);
    font-weight: 600;
    cursor: pointer;
    border: 1px solid var(--color-accent, #1a3a5c);
    background: var(--color-accent, #1a3a5c);
    color: #fff;
    margin-top: 1rem;
}
</style>
